import { Injectable } from '@angular/core';

import {
	AddDeviceToMarketingResponse,
	RemoveDeviceFromMarketingResponse,
	TrackPushResponse,
} from '@reach/interfaces/marketing/marketing.responses';
import { MarketingDevice } from '@reach/interfaces/marketing/marketing.types';

import { BaseApiService } from '~app-client/api/_internal';

@Injectable({ providedIn: 'root' })
export class DevicesApiService extends BaseApiService {
	protected commonPath = ['marketing'];

	public async addDevice(device: MarketingDevice): Promise<AddDeviceToMarketingResponse> {
		const body = device;
		return await this.http.post<AddDeviceToMarketingResponse>(this.url('device'), body);
	}

	public async removeDevice(deviceId: string): Promise<RemoveDeviceFromMarketingResponse> {
		return await this.http.delete<RemoveDeviceFromMarketingResponse>(this.url(deviceId));
	}

	public async trackPush(body: {
		delivery_id: string;
		event: 'opened' | 'delivered' | 'converted';
		device_id: string;
		timestamp: number;
	}): Promise<TrackPushResponse> {
		return await this.http.post<TrackPushResponse>(this.url('track-push'), body);
	}
}
